import React from "react";

const ICONS = {
	templates: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<rect x="3" y="3" width="7" height="7" rx="1" />
			<rect x="14" y="3" width="7" height="7" rx="1" />
			<rect x="3" y="14" width="7" height="7" rx="1" />
			<rect x="14" y="14" width="7" height="7" rx="1" />
		</svg>
	),
	exercices: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M6.5 6.5L17.5 17.5" />
			<path d="M3 17l4 4" />
			<path d="M17 3l4 4" />
			<path d="M5 12l-2 2 4 4 2-2" />
			<path d="M19 12l2-2-4-4-2 2" />
		</svg>
	),
	calendrier: (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<rect x="3" y="4" width="18" height="18" rx="2" />
			<line x1="16" y1="2" x2="16" y2="6" />
			<line x1="8" y1="2" x2="8" y2="6" />
			<line x1="3" y1="10" x2="21" y2="10" />
		</svg>
	),
	"student-programmes": (
		<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
			<path d="M20 6L9 17l-5-5" />
			<path d="M20 14v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h11" />
		</svg>
	),
};

const ITEMS = [
	{ key: "templates", label: "Modèles" },
	{ key: "exercices", label: "Exercices" },
	{ key: "calendrier", label: "Calendrier" },
	{ key: "student-programmes", label: "Ses programmes" },
];

export default function EditorRail({ activePanel, onTogglePanel, user, onExit, items = ITEMS }) {
	return (
		<aside className="editor-rail">
			<button
				className="editor-rail-exit"
				onClick={onExit}
				title="Quitter l'éditeur"
			>
				<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
					<line x1="19" y1="12" x2="5" y2="12" />
					<polyline points="12 19 5 12 12 5" />
				</svg>
				<span>Quitter l'éditeur</span>
			</button>

			<nav className="editor-rail-nav">
				{items.map((it) => (
					<button
						key={it.key}
						className={`editor-rail-btn ${activePanel === it.key ? "active" : ""}`}
						onClick={() => onTogglePanel(it.key)}
						aria-pressed={activePanel === it.key}
					>
						<span className="editor-rail-btn-icon">{ICONS[it.key]}</span>
						<span className="editor-rail-btn-label">{it.label}</span>
					</button>
				))}
			</nav>

			<div
				className="editor-rail-user"
				title={user ? `${user.prenom} ${user.nom}` : "Compte"}
			>
				<span className="editor-rail-user-avatar">
					{((user?.prenom || "?").charAt(0) + (user?.nom || "?").charAt(0)).toUpperCase()}
				</span>
				{user && (
					<span className="editor-rail-user-name">
						{user.prenom} {user.nom?.charAt(0)}.
					</span>
				)}
			</div>
		</aside>
	);
}
